import graphql from 'babel-plugin-relay/macro';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import { QueryRenderer } from 'react-relay';
import { matchPath, withRouter } from 'react-router-dom';
import { withGqlClient, withUser } from 'wrappers';

import LoadingState from '../loadingState';
import Organization from './organization';

const query = graphql`
  query organizationQuery($orgRowId: BigInt!) {
    organizationByRowId(rowId: $orgRowId) {
      ...organization_organization
    }
  }
`;

export const Renderer = ({ error, props: data }) => {
  if (error) return <div>error!</div>;
  if (!data) return <LoadingState fullHeight />;
  const { organizationByRowId } = data;
  return <Organization organization={organizationByRowId} />;
};

Renderer.propTypes = {
  error: PropType.object,
  props: PropType.object
};

Renderer.defaultProps = {
  error: undefined,
  props: undefined
};

export const UserOrganization = props => {
  const { environment, selectedOrganization, location } = props;
  const variables = {};

  // The sidebar must reflect the organization in the URL (the address bar is
  // the source of truth). Only fall back to the selected organization when the
  // URL carries no org id.
  const urlOrgId = matchPath(location?.pathname ?? '', {
    path: '/organization/:orgId',
    exact: false,
    strict: false
  })?.params.orgId;
  const rowId = urlOrgId || selectedOrganization?.rowId;

  // There are some users that have unrealistic data so we need to account
  // for them to not crash the UI.
  if (!rowId) {
    return null;
  }

  variables.orgRowId = rowId;

  // We need to make sure that the location props are passed to child components correctly.
  // https://github.com/ReactTraining/react-router/blob/v4.2.2/packages/react-router/docs/guides/blocked-updates.md
  const RendererWithRouter = withRouter(Renderer);

  return (
    <QueryRenderer
      environment={environment}
      query={query}
      render={RendererWithRouter}
      variables={variables}
    />
  );
};

UserOrganization.propTypes = {
  environment: PropType.object.isRequired,
  location: PropType.object,
  selectedOrganization: PropType.object
};

UserOrganization.defaultProps = {
  location: undefined,
  selectedOrganization: null
};

export default compose(withRouter, withUser, withGqlClient)(UserOrganization);
